export default __webpack_public_path__ + "static/media/complementary--trailers--g1.f2bf02fe.png";